<template>
  <div id="vue-app" class="vue-app">
    <div class="home-top">
      <div class="search-p">
        <van-icon name="search" />
        <input v-model="searchKey" placeholder="请输入姓名/身份证号码" class="input" />
        <p class="line"></p>
        <span class="action" @click="clickSearch()">搜索</span>
      </div>
    </div>
    <div class="card">
          <div class="card-item border-b">
            <span class="label">报到社区</span>
            <span class="content">{{ obj.sysOrgCode_dictText }}</span>
          </div>
          <div class="card-item  border-b">
            <span class="label">擅长领域</span>
            <span class="content">{{ obj.scly_dictText }}</span>
          </div>
          <div class="card-item  border-b">
            <span class="label">参与时间</span>
            <span class="content">{{ obj.bddycysj_dictText }}</span>
          </div>
          <div v-if="obj.bddyyxgz_dictText" class="card-item border-b" style="flex-direction: column;align-items: flex-start;">
            <span class="label">意向工作</span>
            <div class="content" style="text-align: left;margin-top: 8px;">
              <span class="tag" v-for="(tag,index) in obj.bddyyxgz_dictText.split(',')" :key="index">{{tag}}</span>
            </div>
          </div>
    </div>
   

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
        <rkxx-card :list="dataList"></rkxx-card>
      </van-list>
    </van-pull-refresh>
     <van-empty v-if="!loading && dataList.length == 0" style="width: 100%" description="暂无数据" />
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import rkxxCard from '@/views/common/rkxx-card.vue'
export default {
  components: { rkxxCard},
  data() {
    return {
      object: {},
      searchKey: '',
      obj: {},

      loading: true,
      finished: false,
      refreshing: false,
      pageNo: 0,
      dataList: [],
    }
  },
  created() {
    //  this.getToken().then(() => {
    //   this.userInfo = this.getUserInfo()
    //   this.onRefresh()
    // })
    this.initData();
     this.onRefresh();
    // this.$bus.$on('sxrhxx',()=>{
    //   this.onRefresh();
    // })
  },
  activated(){
     
  },
  methods: {
    noPassName(str) {
      var tempStr = ''
      var len = str.length
      var firstStr = str.substr(0, 1)
      var middleStr = str.substring(1, len).replace(/[\s\S]/gi, '*')
      tempStr = firstStr + middleStr
      return tempStr
    },
    clickBack() {
      this.$router.go(-1)
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
    clickSearch() {
      this.onRefresh()
    },
    initData() {
        getAction('/zhshj/djyjdybdzhgx/queryDyxx').then((res) => {
        if (res.success) {
          let obj = res.result[0];
      		this.obj = obj;
        }else{
          this.$toast(res.message)
        }
      })
      },
    getData() {
      let params = {
        queryData: this.searchKey,
        pageNo: this.pageNo,
      }

      getAction('/zhshj/djyjdybdzhgx/pageList', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
          }
          let list = res.result.records
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        } else {
          this.$toast(res.message)
        }
        this.refreshing = false
      })
    },
    clickDj(type) {},
  },
}
</script>

<style scoped lang="less">
.vue-app {
  min-height: 100vh;
  background: #f6f6f6;
}

.home-top {
  background-color: #ffffff;
  padding: 10px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 15px;

  .search-p {
    border: 1px solid #dedede;
    height: 36px;
    flex: 1;
    border-radius: 4px;
    display: flex;
    flex-shrink:0;
    align-items: center;
    padding: 0 8px;

    .input {
      font-size: 14px;
      flex: 1;
      margin-left: 4px;
      flex-shrink:0;
      width: 150px;
      border: none;
    }

    .line {
      width: 1px;
      height: 20px;
      margin: 0 5px;
      background-color: #dedede;
    }

    .action {
      color: #539cff;
      width: 36px;
    
    }
  }

  .add {
    background-color: #539cff;
    height: 35px;
    display: flex;
    width: 64px !important;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    margin-left: 10px;
  }
}

.hsCard {
  background-color: #fff;

  .top {
    height: 38px;
    display: flex;
    border-bottom: 1px solid #dedede;
    border-top: 1px solid #dedede;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #909399;

    .number {
      font-size: 18px;
      color: #539cff;
    }
  }

  .bottom {
    width: 100%;
    overflow: hidden;
    height: 55px;
    > div {
      display: flex;
      height: 60px;
      white-space: nowrap;
      overflow-x: scroll;
      align-items: center;
      > div {
        min-width: 70px;
        flex-shrink: 0;
        flex: 1;
        display: inline-block;
        &:not(:last-child) {
          border-right: 1px solid #dedede;
        }
      }
    }
    .item {
      width: 105px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .number {
        font-size: 16px;
        color: #539cff;
      }

      .unit {
        font-size: 14px;
        color: #909399;
        margin-top: 2px;
      }
    }
  }
}
::v-deep .van-pull-refresh {
  min-height: 100%;
}

  .card {
    background: #fff;
    border-radius: 5px;
    margin-bottom: 5px;
    box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
    padding: 0 10px;
    margin-top: 10px;
  
    .border-b {
      border-bottom: 1px solid #dedede;
    }
  
    .card-item {
      display: flex;
      font-size: 14px;
      align-items: center;
      flex-wrap: wrap;
      padding: 10px 0;
  
      .label {
        width: 65px;
        color: #303133;
      }
  
      .content {
        flex: 1;
        text-align: right;
        color: #606266;
        
        .tag{
          background-color: #539CFF;
          margin: 0 10px 10px 0;
          display: inline-block;
          color: #FFFFFF;
          padding: 4px 6px;
          border-radius: 4px;
          font-size: 13px;
        }
      }
    }
  }
</style>